import { AccountId, PlayerBundle } from "@ollie-sports/models";
import { SimpleQuery } from "@ollie-sports/firebase-lift";

export function getManagedPlayerBundlesForAccountIdFragment(accountId: AccountId): SimpleQuery<PlayerBundle> {
  return { where: [{ managingAccounts: { [accountId]: { exists: ["==", true] } } }, { deletedAtMS: ["==", 0] }] };
}

// i18n certified - complete
